/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const UNIFIED_MONTHS_BETWEEN: Func = {
  label: "MONTHS TILL DATE",
  returnType: "number",

  // Custom jsonLogic builder
  jsonLogic: (args) => ({
    UNIFIED_MONTHS_BETWEEN: [
      args.date, // user-selected value / field / func
      args.cutoff,
      { var: "Start_Unified_Sync_Time" }, // injected field
    ],
  }),

  sqlFunc: "UNIFIED_MONTHS_BETWEEN",

  args: {
    date: {
      label: "From Date",
      type: "date",
      valueSources: ["value", "field", "func"],
    },
    cutoff: {
      label: "Cutoff (months)",
      type: "number",
      valueSources: ["value"],
      fieldSettings: {
        min: 0,
        max: 31
      },
      defaultValue: 0,
    },
  },

  formatFunc: (formattedArgs) =>
    `UNIFIED_MONTHS_BETWEEN(${formattedArgs.date},${formattedArgs.cutoff}, Start_Unified_Sync_Time)`,

  sqlFormatFunc: (formattedArgs) =>
    `UNIFIED_MONTHS_BETWEEN(${formattedArgs.date}, ${formattedArgs.cutoff},Start_Unified_Sync_Time)`,
};

export default UNIFIED_MONTHS_BETWEEN;
